export default "__VITE_ASSET__C$EQs$kj__"